<template>
    <div class="animated slideInRight">
        <div class="m-3 mt-4">
            <div class="row align-items-center">
                <div class="col-md-6 justify-content-center d-flex">
                    <div>
                        <h5>Select a Date</h5>
                        <datepicker :inline="true" v-model="state.scheduleDate" :disabledDates="disabledDates" id="datePicker"></datepicker>
                        <small>The date in which the item will be ready for pickup</small>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="row">
                        <div class="col">
                            <h5 for="timepicker">Select a pickup time</h5>
                            <vue-timepicker
                                format="HH:mm"
                                :minute-interval="15"
                                hide-clear-button
                                v-model="state.scheduleTime"
                                ref="timepicker">
                            </vue-timepicker>
                            <br>
                            <small>The time in which the item will be ready for pickup</small>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col">
                            <h5>Select a closing time</h5>
                            <vue-timepicker
                                format="HH:mm"
                                :minute-interval="15"
                                hide-clear-button
                                v-model="state.scheduleClosingTime"
                                ref="timepickerClosing">
                            </vue-timepicker>
                            <br>
                            <small>The time in which your business closes</small>
                        </div>
                    </div>
                    <br>
                    <div class="form-group">
                        <h5>Timezone</h5>
                        <select class="custom-select" placeholder="Select a Timezone" v-model="state.scheduleTimezone" id="locationSelect">
                            <option
                                v-for="option in $moment.tz.names()"
                                :value="option"
                                :key="option">
                                {{ option }}
                            </option>
                        </select>
                        <small>By default this is your timezone</small>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col">
                            <div class="btn btn-primary float-right" v-on:click="tryGoToNextStep">
                                <span v-if="!isClickedContinue">Continue</span>
                                <div class="lds-ring" v-if="isClickedContinue"><div></div><div></div><div></div><div></div></div>
                            </div>
                            <div class="btn btn-danger float-right mr-2" v-on:click="goToRoot">Cancel</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Step from '@/mixins/step'
    import VueTimepicker from 'vue2-timepicker'
    import Datepicker from 'vuejs-datepicker'

    export default {
        mixins: [ Step ],
        components: { VueTimepicker, Datepicker },
        name: 'StepSchedule',
        data () {
            return {
                disabledDates: {
                    to: new Date(new Date().setDate(new Date().getDate() - 1)), // Set selectable date ONLY from today
                    days: [6, 0]
                },
                isClickedContinue: false
            }
        },
        mounted () {
            // Allow between >=9 and <4
            this.$refs.timepicker.hours = this.$refs.timepicker.hours.slice(9, 16)
            this.$refs.timepickerClosing.hours = this.$refs.timepickerClosing.hours.slice(9, 24)
        },
        filters: {},
        computed: {},
        methods: {
            /**
             * Make Manifest Consignment Public Request
             *
             */
            makeManifestReturnConsignmentPublicRequest: function () {
                // This = that
                let that = this

                // Setup the basic object to populate
                let requestParams = {
                    request: 'ManifestReturnConsignmentPublic',
                    return: this.state.consignmentReturnCode,
                    pickup_timezone: this.state.scheduleTimezone,
                    pickup_ready: this.state.combinedDateTime.format('YYYY-MM-DD HH:mm:ss'),
                    pickup_closing: this.state.combinedClosingDateTime.format('YYYY-MM-DD HH:mm:ss'),
                    pickup_is_required: true,
                    send_tracking_emails: true,
                    consignments: {
                        1: this.state.consignmentData.consignment
                    }
                }

                // On the page load we load the config
                this.$http.post('/', requestParams).then(response => {
                    // Check if there's any errors
                    if (!that.state.messages.check200ResponseForErrors(response.data)) {
                        // Save the response
                        that.state.manifestData = response.data
                        // Move to print page
                        that.goToNextStep()
                    }
                }).catch(e => {
                    that.state.messages.addErrorsFrom400Response(e)
                }).finally(() => {
                    this.isClickedContinue = false
                })
            },
            /**
             * Make Update Return Consignment Public Request
             *
             */
            makeUpdateReturnConsignmentPublicRequest: function () {
                this.isClickedContinue = true
                // This = That
                let that = this

                // Setup the basic object to populate
                let requestParams = {
                    request: 'UpdateReturnConsignmentPublic'
                }

                // Manually set fields
                requestParams['return'] = this.state.consignmentReturnCode
                requestParams['is_return'] = that.state.consignmentData['is_return']
                requestParams['despatch_date'] = this.$moment(this.state.scheduleDate).format('YYYY-MM-DD HH:mm:ss')

                // WE USED TO INHERIT THIS META...
                // Add general bits of meta
                /* let generalMeta = ['despatch_date', 'ref', 'special_instructions',
                    'pallets_chep', 'pallets_loscam', 'pallets_other',
                    'cost_centre', 'is_return', 'consolidate_check', 'service_code']
                generalMeta.forEach(function (value) {
                    requestParams[value] = that.state.consignmentData[value]
                }) */
                // Add the Sender / Reciver details
                /* let senderReceiverMeta = ['_name', '_contact', '_email', '_phone', '_address_1', '_address_2', '_town', '_postcode', '_state']
                senderReceiverMeta.forEach(function (value) {
                    requestParams['sender' + value] = that.state.consignmentData['sender' + value]
                    requestParams['receiver' + value] = that.state.consignmentData['receiver' + value]
                }) */

                // Dynamically create empty arrays like (items_width, items_height)
                this.state.fieldsForItems.forEach(function (fieldValue) {
                    requestParams['items_' + fieldValue] = []
                })
                // Dynamically populate previously created empty arrays
                this.state.items.forEach(function (itemValue, itemKey) {
                    // Populate our items array
                    that.state.fieldsForItems.forEach(function (fieldValue) {
                        if (typeof itemValue[fieldValue] !== 'undefined') {
                            requestParams['items_' + fieldValue].push(itemValue[fieldValue])
                        } else {
                            requestParams['items_' + fieldValue].push(null)
                        }
                    })
                })

                // Do the request UpdateReturnConsignmentPublic
                this.$http.post('/', requestParams).then(response => {
                    // Check if there's any errors
                    if (!that.state.messages.check200ResponseForErrors(response.data)) {
                        // Save the response
                        that.state.updatedConsignmentData = response.data
                        // Go to the printing step
                        that.makeManifestReturnConsignmentPublicRequest()
                    }
                }).catch(e => {
                    that.state.messages.addErrorsFrom400Response(e)
                })
            },
            /**
             * Try Go To Next Step
             *
             * Check whether date and time have been entered.
             * If indeed it has been we'll advanced the step
             */
            tryGoToNextStep: function () {
                // Clear previous error messages
                this.state.messages.clearMessages()
                // Validation Result
                let validationResult = true

                // Get the date and time values
                let HH = this.state.scheduleTime.HH
                let mm = this.state.scheduleTime.mm
                let HHClosing = this.state.scheduleClosingTime.HH
                let mmClosing = this.state.scheduleClosingTime.mm
                let date = this.state.scheduleDate
                let timezone = this.state.scheduleTimezone

                // Timezone validation
                if (!timezone) {
                    // Most likely it's empty or null...
                    this.state.messages.addMessage('Please select a timezone', 0)
                    // Don't let us go to the next step just yet..
                    validationResult = false
                }

                // Time validation
                if (!HH || !mm) {
                    // Most likely it's empty or null...
                    this.state.messages.addMessage('Please select a time', 0)
                    // Don't let us go to the next step just yet..
                    validationResult = false
                }

                // Closing time validation
                if (!HHClosing || !mmClosing) {
                    // Most likely it's empty or null...
                    this.state.messages.addMessage('Please select a closing time', 0)
                    // Don't let us go to the next step just yet..
                    validationResult = false
                }

                // Validate closing time is greater then delivery time
                if ((HHClosing < HH) || (HHClosing === HH && mmClosing <= mm)) {
                    this.state.messages.addMessage('Closing time must be greater then pickup time', 0)
                    // Don't let us go to the next step just yet..
                    validationResult = false
                }

                // Date validation
                if (!date) {
                    // Most likely it's empty or null...
                    this.state.messages.addMessage('Please select a date', 0)
                    // Don't let us go to the next step just yet..
                    validationResult = false
                }

                // Return the actual result
                if (validationResult) {
                    this.makeUpdateReturnConsignmentPublicRequest()
                }
            },
            /**
             * Generate Date
             *
             * This takes the inputted time/timezone/date fields and generates the proper date
             */
            generateDate: function () {
                // Ensure they're both set (if not this will be picked up in the validation in tryGoToNextStep)
                if (this.state.scheduleTime.HH && this.state.scheduleTime.mm && this.state.scheduleDate) {
                    this.state.combinedDateTime = this.$moment(this.state.scheduleDate)
                    this.state.combinedDateTime.hour(this.state.scheduleTime.HH)
                    this.state.combinedDateTime.minute(this.state.scheduleTime.mm)
                }
                // Ensure they're both set (if not this will be picked up in the validation in tryGoToNextStep)
                if (this.state.scheduleClosingTime.HH && this.state.scheduleClosingTime.mm && this.state.scheduleDate) {
                    this.state.combinedClosingDateTime = this.$moment(this.state.scheduleDate)
                    this.state.combinedClosingDateTime.hour(this.state.scheduleClosingTime.HH)
                    this.state.combinedClosingDateTime.minute(this.state.scheduleClosingTime.mm)
                }
            }
        },
        watch: {
            /**
             * Watch Schedule Time
             *
             * We watch this so we can compile our compiled date from the date and time objects
             */
            'state.scheduleTime': function (oldVal, newVal) {
                this.generateDate()
            },
            /**
             * Watch Schedule Time
             *
             * We watch this so we can compile our compiled date from the date and time objects
             */
            'state.scheduleClosingTime': function (oldVal, newVal) {
                this.generateDate()
            },
            /**
             * Watch Schedule Date
             *
             * We watch this so we can compile our compiled date from the date and time objects
             */
            'state.scheduleDate': function (oldVal, newVal) {
                this.generateDate()
            },
            /**
             * Watch Schedule Date
             *
             * We watch this so we can compile our compiled date from the date and time objects
             */
            'state.scheduleTimezone': function (oldVal, newVal) {
                this.$moment.tz.setDefault(this.state.scheduleTimezone)
                this.generateDate()
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .lds-ring {
        display: inline-block;
        position: relative;
        width: 25px;
        height: 17px;
    }
    .lds-ring div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 20px;
        height: 20px;
        margin: 2px;
        border: 4px solid #fff;
        border-radius: 50%;
        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: #fff transparent transparent transparent;
    }
    .lds-ring div:nth-child(1) {
        animation-delay: -0.45s;
    }
    .lds-ring div:nth-child(2) {
        animation-delay: -0.3s;
    }
    .lds-ring div:nth-child(3) {
        animation-delay: -0.15s;
    }
    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>
